import React, { ReactNode, VFC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ArrowForwardIos from '@material-ui/icons/ArrowForwardIos';

const withStyles = makeStyles((theme) => ({
  root: {
    marginTop: 0,
    color: theme.palette.common.white,
    borderRadius: '50px',
    backgroundColor: '#35af87',
    textTransform: 'none',

    '&:hover': {
      color: theme.palette.common.white,
      backgroundColor: '#35af87',
      opacity: 0.7,
    },
  },
}));

interface Props {
  href: string;
  target?: string;
  children: ReactNode;
}
const GreenButtonLink: VFC<Props> = ({ href, target, children }: Props) => {
  const { root } = withStyles();
  return (
    <Button
      color="primary"
      variant="contained"
      disableElevation
      component="a"
      href={href}
      target={target}
      classes={{ root }}
    >
      {children}
      <ArrowForwardIos fontSize="small" />
    </Button>
  );
};

export default GreenButtonLink;
